module.exports = __webpack_public_path__ + "img/cubiculos-3.d4ad1cac.jpg";